import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { groupBy } from 'lodash-es'
import { HolidayDetail } from 'api'
import { EnvironmentTitle, HeroPanel, DetailTilesContainer, BannerStatusTile, BannerTilesGroup } from 'view/shared/heroPanel'
import { holidayDetailsSelector } from 'selectors/holidaySelectors'
import { WindowActions } from 'epics/windowEpic'
import { Locale, Translation } from 'locale'

interface HolidayHeroPanelProps {
  holidayList: HolidayDetail[]
  onTearout: () => void
}

const mapStateToProps = createStructuredSelector({
  holidayList: holidayDetailsSelector
})

const mapDispatchToProps = {
  onTearout: () => WindowActions.tearoutGrid('/quote/tearout/admin/holidays')
}

const HolidayHeroPanelComponent: React.FunctionComponent<HolidayHeroPanelProps> = props => {
  const { holidayList, onTearout } = props
  const holidaysByCurrency = groupBy(holidayList, holidayDetail => holidayDetail.holiday.currency)

  return (
    <HeroPanel onTearout={onTearout}>
      <DetailTilesContainer>
        <EnvironmentTitle data-test-id={'HolidayHeroPanel-EnvironmentTitle'}>
          {Locale.translate(Translation.TC_HERO_HOLIDAYS)}
        </EnvironmentTitle>
        <BannerTilesGroup title={Locale.translate(Translation.TC_HERO_SUMMARY)}>
          <BannerStatusTile title={Locale.translate(Translation.TC_TOTAL)} label={holidayList.length} />
          {Object.keys(holidaysByCurrency).map(currency => (
            <BannerStatusTile key={currency} title={currency} label={holidaysByCurrency[currency].length} />
          ))}
        </BannerTilesGroup>
      </DetailTilesContainer>
    </HeroPanel>
  )
}

export const HolidayHeroPanel = connect(mapStateToProps, mapDispatchToProps)(HolidayHeroPanelComponent)
